<template>
  <fullscreen :fullscreen.sync="fullscreen" :teleport="teleport" :page-only="pageOnly">
  <v-app>
    <dashboard-core-app-bar @fullScreen="fullScreen" />  
    <dashboard-core-drawer />
    <dashboard-core-view />
  </v-app>
  </fullscreen>
</template>

<script>
import DashboardCoreAppBar from '@/components/Dashboard/AppBar' 
import DashboardCoreView from '@/components/Dashboard/View' 
import DashboardCoreDrawer from '@/components/Dashboard/Drawer'
import VueFullscreen from 'vue-fullscreen'
import Vue from 'vue'
Vue.use(VueFullscreen) 
export default {
  components: {
    DashboardCoreAppBar,
    DashboardCoreView,
    DashboardCoreDrawer
  },
  name: 'PagesIndex',
  data: () => ({ 
    fullscreen: false,
    teleport: false,
    pageOnly: false
  }),
  created() {
    setTimeout(() => {
      
    }, 2000)
  },
  methods: {
    fullScreen() {
      this.fullscreen = !this.fullscreen
    }
  }
  
}
</script>
<style>

</style>